import { render, staticRenderFns } from "./upload-button.vue?vue&type=template&id=108a0c51"
import script from "./upload-button.vue?vue&type=script&lang=js"
export * from "./upload-button.vue?vue&type=script&lang=js"
import style0 from "./upload-button.vue?vue&type=style&index=0&id=108a0c51&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports